// extracted by mini-css-extract-plugin
var _1 = "account-detail-container__dLUwh";
var _2 = "bank-icon-container__NbxqB";
var _3 = "link-container__bwnNL";
var _4 = "payment-info-container__wSVve";
export { _1 as "accountDetailContainer", _2 as "bankIconContainer", _3 as "linkContainer", _4 as "paymentInfoContainer" }
